import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminUserHistoryDTO } from "@shaarp/common";

export default function DataTableCellAdminUsersHistoryUserAvatar({
  userHistory,
}: {
  userHistory: AdminUserHistoryDTO;
}) {
  const { t } = useTranslation();

  if (!userHistory.user) {
    return t("admin.dataTableAdminUsersHistory.user.unknown");
  }

  return (
    <div className="flex items-center">
      <Avatar className="w-9 h-9">
        <AvatarImage
          src={userHistory.user.imageUrl}
          alt={userHistory.user.fullName}
        />
      </Avatar>
      <span className="ml-2">{userHistory.user.fullName}</span>
    </div>
  );
}
